module.exports = __webpack_public_path__ + "img/bees_knees.9ac0db7e.jpg";